import * as actionTypes from './constants';
import settingsService from '../admin/settings/service/SettingsService';

// Get Settings by using params
export default (withDvrToolkitData = false) => async dispatcher => {
  dispatcher({type: actionTypes.GET_REQUEST});

  try {
    const customer = await settingsService.getSettings(withDvrToolkitData);

    dispatcher({
      type: actionTypes.GET_SUCCESS,
      payload: customer
    });

    return customer;
  } catch (e) {
    console.error('Something went wrong when loading customer settings:', e);

    dispatcher({
      type: actionTypes.GET_FAIL
    });
  }
};